export default __webpack_public_path__ + "static/media/warning--y-roads--g1.1dc031ba.png";